"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanRenderingData = cleanRenderingData;
exports.mockLocation = mockLocation;
exports.getRenderingData = getRenderingData;
exports.setRenderingData = setRenderingData;
exports.setRenderingValue = setRenderingValue;
exports.setRenderingValueToData = setRenderingValueToData;
exports.getRenderingValue = getRenderingValue;
exports.removeRenderingData = removeRenderingData;
exports.setRenderingHeader = setRenderingHeader;
exports.getRenderingHeaders = getRenderingHeaders;
function getWindow() {
    // @ts-expect-error Fake window for server
    if (!global.window)
        global.window = {};
    // @ts-expect-error Set rendering data for router and hooks to fetch data
    if (!global.window.RENDERING_DATA)
        global.window.RENDERING_DATA = {};
    // @ts-expect-error Set rendering headers SSR SEO
    if (!global.window.RENDERING_HEADERS)
        global.window.RENDERING_HEADERS = {};
    // @ts-expect-error Return fake window for SSR or window for browser
    return global.window;
}
function cleanRenderingData() {
    var window = getWindow();
    window.RENDERING_DATA = {};
    window.RENDERING_HEADERS = {};
}
function mockLocation(href) {
    getWindow().location = new URL(href);
}
function getRenderingData() {
    return __assign({}, getWindow().RENDERING_DATA);
}
function setRenderingData(data) {
    getWindow().RENDERING_DATA = __assign({}, data);
}
function setRenderingValue(url, data) {
    setRenderingValueToData(getWindow().RENDERING_DATA, url, data);
}
function setRenderingValueToData(renderingData, url, data) {
    if (data === null) {
        renderingData[url] = null;
    }
    else if (data instanceof Error) {
        renderingData[url] = { type: "error", message: data.message };
    }
    else {
        renderingData[url] = { type: "data", value: data };
    }
}
function getRenderingValue(url) {
    var value = getRenderingData()[url];
    if (value === undefined) {
        setRenderingValue(url, null);
        return null;
    }
    if (value === null) {
        return null;
    }
    else if (value.type === "error") {
        return new Error(value.message);
    }
    else {
        return value.value;
    }
}
function removeRenderingData(url) {
    delete getWindow().RENDERING_DATA[url];
}
function setRenderingHeader(key, value) {
    getWindow().RENDERING_HEADERS[key] = value;
}
function getRenderingHeaders() {
    var _a;
    var window = getWindow();
    var headers = window.RENDERING_HEADERS;
    if (!headers.title) {
        var title = (_a = window === null || window === void 0 ? void 0 : window.document) === null || _a === void 0 ? void 0 : _a.title;
        if (title)
            headers.title = title;
    }
    return headers;
}
